'use es6';

import { TIME_SERIES } from '../constants/configTypes';
export const isMismatchedDimensionDateFilterPropertyTimeSeries = report => {
  const dimensions = report.getIn(['config', 'dimensions']);
  return report.getIn(['config', 'configType']) === TIME_SERIES && dimensions && dimensions.size === 1 && dimensions.get(0) !== report.getIn(['config', 'filters', 'dateRange', 'property']);
};